import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { useAuthenticatedUser, useFeature } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Breakpoint, Container, Heading, Separator, tokens } from '@treams/treams-ui';

import CycleMomentsPreview from '../../../kakapo-ui-kit/components/cycles/CycleMomentsPreview';
import IntercomTarget from '../../common/containers/IntercomTarget';
import InboxPersonalSidebar, { InboxPersonalCheckpoints } from './InboxPersonalSidebar';
import InboxTabBar from './InboxTabBar';
import InboxTasksContainer from './InboxTasksContainer';

const Layout = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${tokens.gap.section}px;

	@media screen and (min-width: ${Breakpoint.Large}) {
		display: grid;
		grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
		column-gap: ${tokens.gap.section}px;
		row-gap: ${tokens.gap.page}px;
		grid-template-areas:
			'cycles profile'
			'tasks checkpoints';
		align-items: start;
	}
`;

const Cycles = styled.div`
	min-width: 0;

	@media screen and (min-width: ${Breakpoint.Large}) {
		grid-area: cycles;
	}
`;

const Tasks = styled.div`
	min-width: 0;

	@media screen and (min-width: ${Breakpoint.Large}) {
		grid-area: tasks;
	}
`;

const Profile = styled.div`
	min-width: 0;
	padding-top: ${tokens.gap.section}px;

	@media screen and (min-width: ${Breakpoint.Large}) {
		grid-area: profile;
		padding-top: 0;
	}
`;

const Checkpoints = styled.div`
	min-width: 0;

	@media screen and (min-width: ${Breakpoint.Large}) {
		grid-area: checkpoints;
	}
`;

export function InboxPersonalContainerWithoutSidebar(props: { header?: boolean }) {
	const { t } = useTranslation();

	const showCycles = useFeature(graphql.FeatureName.Cycles);

	const viewer = useAuthenticatedUser();

	return (
		<IntercomTarget target="inbox" block>
			<Container wide={1000} mt={`${tokens.gap.page}px`} mb={`${tokens.gap.page}px`}>
				{props.header !== false && (
					<Box mb={3}>
						<Flex flexDirection={['column', 'row', 'row']} alignItems={['flex-start', 'flex-end']}>
							<Box mb={2} flexGrow={1} flexShrink={1}>
								<Heading>{t('inbox.title', { name: viewer.firstName })}</Heading>
							</Box>
							<InboxTabBar />
						</Flex>
						<Separator />
					</Box>
				)}
				<Layout>
					{showCycles && (
						<Cycles>
							<CycleMomentsPreview userID={viewer.id} />
						</Cycles>
					)}
					<Tasks>
						<InboxTasksContainer hasCounter showEmptyState />
					</Tasks>
					<Profile>
						<InboxPersonalSidebar />
					</Profile>
					<Checkpoints>
						<InboxPersonalCheckpoints />
					</Checkpoints>
				</Layout>
			</Container>
		</IntercomTarget>
	);
}
